<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2022-07-12 16:19:17
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-12-13 19:37:29
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/volvo202207/components/video.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
    视频模块
-->
<template>
  <div id="video" :class="type == 'nobg'?'nobg':''">
    <video
      ref="video"
      v-if="src"
      data-v-3b1260f5=""
      :id="'video' + id"
      :src="src"
      controls="controls"
      webkit-playsinline=""
      :poster="poster"
      playsinline=""
      x5-video-player-type="h5"
      class="video__player poster"
    >
      抱歉，您的浏览器不支持内嵌视频
    </video>
    <img v-if="!src" :src="poster" alt="">
    <div v-if="!src" class="thank">
      <img src="https://source.qunarzz.com/site/images/wns/20220919-shijianchen-play2.png" class="play" alt="">
      敬请期待
    </div>
  </div>
</template>
<script>
import maidian from '@/utils/maidian';
export default {
  props: ['poster','test', 'src', 'auto','type'],
  data() {
    return {
      playing: false,
      id: +new Date(),
    };
  },
  mounted() {
    if (this.auto) {
      setTimeout(() => {
        var video = document.getElementById('video' + this.id);
        video.play();
      }, 0);
      document.addEventListener(
        'WeixinJSBridgeReady',
        () => {
          var video = document.getElementById('video' + this.id);
          video.play();
        },
        false,
      );
      document.addEventListener(
        'touchstart',
        () => {
          if (this.playing) return;
          var video = document.getElementById('video' + this.id);
          video.play();
          this.playing = true;
        },
        false,
      );
    }

    let video = document.getElementById('video' + this.id);
    video.addEventListener('playing', () => {
      maidian.eventBind('video' + this.id);
      self.$emit('playing');
    });
  },
};
</script>
<style lang="less" scoped>
#video {
  width: 100%;
  height: 100%;
  min-height: 200px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  box-sizing: border-box;
  border-radius: 8px;
  &.nobg{
    background-image: unset;
    padding:0;
  }
  position: relative;
  .thank{
    display: block;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    font-size: 18px;
    color:#fff;
    font-weight: bold;
    img{
      display: block;
      width:40px;
      margin:0 auto;
      margin-bottom: 10px;
    }
  }
}
.empty {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #333;
  background-color: #eee;
}
video {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  display: block;
}
</style>